// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__19Cf3","signatureBlock":"Footer_signatureBlock__2T8oh","signature":"Footer_signature__2RWat"};